import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const cropScheduleVariantList = createAsyncThunk('cropScheduleVariantList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'crop-schedule-variants',
            params: {
                ...(data?.crop_id ? { 'crop_id': data.crop_id } : {}),
                ...(data?.has_schedule !== undefined && data?.has_schedule !== null && data?.has_schedule !== ''
                    ? { 'has_schedule': data.has_schedule }
                    : {}),
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const cropScheduleVariantListSlice = createSlice({
    name: 'cropScheduleVariantList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(cropScheduleVariantList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const payloadData = action.payload.data.data;
                state.data = payloadData?.rows ?? payloadData ?? [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(cropScheduleVariantList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default cropScheduleVariantListSlice.reducer;
